import { AxiosError } from "axios";

import { api } from "@/lib/axios";

interface updateAcademyTrainingModuleAvailableData {
	available: boolean;
}

export async function updateAcademyTrainingLessonAvailable(
	data: updateAcademyTrainingModuleAvailableData,
	id: string,
): Promise<
	| {
			status: "success";
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		await api.put(`/lesson/set-available/${id}`, data);

		return {
			status: "success",
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
